import {OrdersToBeFilled, OrdersToBeDelivered, OrdersDelivered} from '../../components/charts'

const init = () => {
  OrdersToBeFilled()
  OrdersToBeDelivered()
  OrdersDelivered()
}

export default init
